import * as React from 'react';
import '../css/dropdowns.sass';

interface DropdownOptionProps {
  id?: string;
  label?: string;
  selected?: boolean;
  active?: boolean;
  value: string;
  iconPath?: string;
  additionalText?: string;
  onSelect: Function;
  theme?: 'night' | 'day';
}

export default function DropdownOptionLi(props: DropdownOptionProps) {
  const style: any = {};
  if (props.label) {
    style.height = '65px';
  }
  const { theme = 'day' } = props;
  return (
    <li
      role="option"
      aria-selected={props.active}
      style={style}
      className={`dropdown__list-item${props.selected ? ' selected' : ''}${
        !props.selected && props.active ? ' activeOption' : ''
      } ${theme}`}
      onClick={() => {
        props.onSelect();
      }}
      onKeyDown={(e: any) => {
        if (e.keyCode === 32 || e.keyCode === 13) {
          props.onSelect();
        }
      }}
      id={props.id}
    >
      {props.label && (
        <>
          <label htmlFor={props.id}>{props.label}</label>
          <br />
        </>
      )}
      <em>
        <span
          className={`item-details${
            props.additionalText ? ' item-details-text' : ''
          }`}
        >
          {props.iconPath && <img alt="" src={props.iconPath} />}
          {props.value}
        </span>
        {!!props.additionalText && (
          <div className="item-additional-text">{props.additionalText}</div>
        )}
      </em>
    </li>
  );
}
